<template>
    <div class="container-fluid">
        <Breadcrumb title="Socks Proxies" button-url="socksProxyCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="resetActivity"><i
                                    class="fa fa-sync"></i>
                                    Restore Socks Activity
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2"
                                    @click="deleteInactive"><i
                                    class="fa fa-times"></i>
                                Remove Inactive Socks
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2"
                                    @click="deleteAll"><i
                                    class="fa fa-times"></i>
                                Remove All Socks
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                />
                            </div>
                            <input v-model="ipSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by IP address">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="socksList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>ID</span>
                                                </th>
                                                <th @click="tableOrdering('ip')">
                                                    <span role='button'>IP</span>
                                                </th>
                                                <th>Port</th>
                                                <th @click="tableOrdering('active')">
                                                    <span role='button'>Active</span>
                                                </th>
                                                <th v-if="isAdmin">Owner</th>
                                                <th>Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(socks, index) in socksList" :key="index">
                                                <td class="align-middle">{{socks.id}}</td>
                                                <td class="align-middle">{{socks.ip}}</td>
                                                <td class="align-middle">{{socks.port}}</td>
                                                <td class="align-middle">{{socks.active}}</td>
                                                <td class="align-middle" v-if="isAdmin">{{socks.user.username}}</td>
                                                <td class="align-middle">
                                                    <router-link
                                                            :to="{ name: 'socksProxyEdit', params: { id: socks.id }}"
                                                            class="btn btn-sm btn-info m-r-10">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </router-link>
                                                    <button type="button" class="btn btn-sm btn-success m-r-10"
                                                            @click="checkSocks(socks.id)">
                                                        <i class="fa fa-minus-circle"></i> Check
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                            @click="deleteSocks(socks.id)">
                                                        <i class="fa fa-minus-circle"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate v-if="pageCount > 1"
                                              v-model="page"
                                              :page-count="pageCount"
                                              :page-range="3"
                                              :margin-pages="2"
                                              :click-handler="getItems"
                                              :prev-text="'Prev'"
                                              :next-text="'Next'"
                                              :container-class="'pagination justify-content-center'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="swalHtml" v-show="false">
            <select class="form-control" v-model="ownerSelect" ref='swalHtml' v-if="this.$store.getters.isAdmin">
                <option disabled value="null">Just for my socks</option>
                <option v-for="(user, index) in userList" :key="index" v-bind:value="user.id">{{user.label}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import SocksProxyService from '../services/SocksProxyService';
    import UserService from '../services/UserService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'SocksProxies',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                isAdmin: this.$store.getters.isAdmin,
                orderField: 'id',
                orderDirection: 'asc',
                socksList: [],
                ipSearch: null,
                userSearch: null,
                userList: null,
                ownerSelect: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                SocksProxyService.getSocksProxies(
                    pageNum,
                    this.perPage,
                    this.orderField,
                    this.orderDirection,
                    this.userSearch,
                    this.ipSearch
                ).then(response => {
                    this.socksList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            tableOrdering(field) {
                if (this.orderField === field) {
                    this.orderDirection = (this.orderDirection === 'asc') ? 'desc' : 'asc';
                } else {
                    this.orderField = field;
                    this.orderDirection = 'asc';
                }
                this.getItems(this.page = 1);
            },
            deleteSocks(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SocksProxyService.deleteSocksProxy(id).then((response) => {
                            if (response.status === 204) {
                                let socksIndex = this.socksList.findIndex(obj => obj.id === id);
                                this.socksList.splice(socksIndex, 1);
                                this.totalItems--;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Socks has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            checkSocks(id) {
                Swal({
                    title: 'Checking Socks health',
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                    onOpen: () => {
                        SocksProxyService.checkSocksProxy(id).then((response) => {
                            let result = response.data;
                            Swal.hideLoading();
                            Swal({
                                type: result.result ? 'success' : 'error',
                                title: result.msg,
                                text: result.boundIp ? ('Bound IP: ' + result.boundIp) : ''
                            })
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    }
                })
            },
            resetActivity() {
                Swal({
                    type: 'question',
                    title: 'Make All inactive socks active?',
                    html: this.$refs.swalHtml,
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SocksProxyService.resetSocksProxiesActivity(this.ownerSelect).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Successfully reset!'
                        )
                    }
                    this.getItems(this.page = 1);
                })
            },
            deleteInactive() {
                Swal({
                    type: 'question',
                    title: 'Remove all inactive socks?',
                    html: this.$refs.swalHtml,
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SocksProxyService.deleteInactiveSocks(this.ownerSelect).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Successfully removed!'
                        )
                    }
                    this.getItems(this.page = 1);
                })
            },
            deleteAll() {
                Swal({
                    type: 'question',
                    title: 'Remove all socks?',
                    html: this.$refs.swalHtml,
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SocksProxyService.deleteAllSocks(this.ownerSelect).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Successfully removed!'
                        )
                    }
                    this.getItems(this.page = 1);
                })
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>